import { Component } from '@angular/core';

@Component({
  selector: 'hdw-header',
  templateUrl: './hdw-header.component.html',
  styleUrls: ['./hdw-header.component.scss']
})
export class HdwHeaderComponent {}
